import { call, put, takeLatest, select } from "redux-saga/effects";
import { PROYECT, api_get, api_put } from "services/api";
import {
  getStations,
  orderCompaniesAndStations,
} from "helpers/companiesNormalized";

// data
const LOAD_DATA_UPDATE_PRICES = "LOAD_DATA_UPDATE_PRICES";
const SET_DATA_UPDATE_PRICES = "SET_DATA_UPDATE_PRICES";
const ERROR_DATA_UPDATE_PRICES = "ERROR_DATA_UPDATE_PRICES";

// prices
const LOAD_PRICES_UPDATE_PRICES = "LOAD_PRICES_UPDATE_PRICES";
const SET_PRICES_UPDATE_PRICES = "SET_PRICES_UPDATE_PRICES";
const ERROR_PRICES_UPDATE_PRICES = "ERROR_PRICES_UPDATE_PRICES";

// update price
const SEND_NEW_PRICE_UPDATE_PRICES = "SEND_NEW_PRICE_UPDATE_PRICES";
const SET_NEW_PRICE_UPDATE_PRICES = "SET_NEW_PRICES_UPDATE_PRICES";
const ERROR_NEW_PRICE_UPDATE_PRICES = "ERROR_NEW_PRICES_UPDATE_PRICES";

// filters
const CHANGE_COMPANY_UPDATE_PRICES = "CHANGE_COMPANY_UPDATE_PRICES";
const CHANGE_STATION_UPDATE_PRICES = "CHANGE_STATION_UPDATE_PRICES";

// general
const CLEAR_UPDATE_PRICES = "CLEAR_DATA_UPDATE_PRICES";
const CLEAR_ERROR_UPDATE_PRICES = "CLEAR_ERROR_UPDATE_PRICES";

const INITIAL_STATE = {
  companies: [],
  stations: [],
  isLoading: false,
  error: false,
  message: "",
  errorMessage: "",
  // prices
  prices: [],
  isLoadingPrices: false,
  // filters
  companySelected: "",
  stationSelected: "",
  nameStation: "",
  companyStations: [],
  // update price
  isLoadingNewPrice: false,
};

const updatePriceReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case LOAD_DATA_UPDATE_PRICES:
      return {
        ...state,
        companies: [],
        stations: [],
        companyStations: [],
        isLoading: true,
        error: false,
        message: "",
        errorMessage: "",
      };
    case SET_DATA_UPDATE_PRICES:
      return {
        ...state,
        companies: payload.companies,
        stations: payload.stations,
        isLoading: false,
      };
    case ERROR_DATA_UPDATE_PRICES:
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: payload.message,
      };
    case CLEAR_UPDATE_PRICES:
      return {
        ...state,
        ...INITIAL_STATE,
      };
    case LOAD_PRICES_UPDATE_PRICES:
      return {
        ...state,
        prices: [],
        isLoadingPrices: true,
        error: false,
        message: "",
        errorMessage: "",
      };
    case SET_PRICES_UPDATE_PRICES:
      return {
        ...state,
        prices: payload.prices,
        isLoadingPrices: false,
      };
    case ERROR_PRICES_UPDATE_PRICES:
      return {
        ...state,
        isLoadingPrices: false,
        error: true,
        errorMessage: payload.message,
      };
    case CHANGE_COMPANY_UPDATE_PRICES:
      return {
        ...state,
        companySelected: payload.company,
        companyStations: payload.stations,
      };
    case CHANGE_STATION_UPDATE_PRICES:
      return {
        ...state,
        stationSelected: payload,
      };

    case SEND_NEW_PRICE_UPDATE_PRICES:
      return {
        ...state,
        isLoadingNewPrice: true,
        error: false,
        errorMessage: "",
        message: "",
      };
    case SET_NEW_PRICE_UPDATE_PRICES:
      const { id, price } = payload.product;
      const newPrices = [...state.prices];

      const index = newPrices.findIndex((price) => price.id === id);

      if (index !== -1) {
        newPrices[index].price = price;
      }

      return {
        ...state,
        isLoadingNewPrice: false,
        prices: newPrices,
      };
    case ERROR_NEW_PRICE_UPDATE_PRICES:
      return {
        ...state,
        isLoadingNewPrice: false,
        error: true,
        errorMessage: payload.message,
      };
    case CLEAR_ERROR_UPDATE_PRICES:
      return {
        ...state,
        error: false,
        errorMessage: "",
      };

    default:
      return state;
  }
};

function getData() {
  return {
    type: LOAD_DATA_UPDATE_PRICES,
  };
}

function getPrices(id) {
  return {
    type: LOAD_PRICES_UPDATE_PRICES,
    payload: {
      id,
    },
  };
}

function sendNewPrice(id, idStation, body) {
  return {
    type: SEND_NEW_PRICE_UPDATE_PRICES,
    payload: {
      id,
      idStation,
      body,
    },
  };
}

function changeCompany(company, stations) {
  return {
    type: CHANGE_COMPANY_UPDATE_PRICES,
    payload: { company, stations },
  };
}
function changeStation(station) {
  return {
    type: CHANGE_STATION_UPDATE_PRICES,
    payload: station,
  };
}
function clearError() {
  return {
    type: CLEAR_ERROR_UPDATE_PRICES,
  };
}

function* fetchData() {
  const token = yield select((state) => state.login.token);
  const auth = { headers: { authorization: `${token}` } };
  const url = `${process.env.REACT_APP_URL}${PROYECT}/companies`;
  try {
    const response = yield call(api_get, url, auth);

    const stations = getStations(response.companies);
    const orderedCompanies = orderCompaniesAndStations(response.companies);

    yield put({
      type: SET_DATA_UPDATE_PRICES,
      payload: {
        companies: orderedCompanies,
        stations,
      },
    });
  } catch (message) {
    yield put({
      type: ERROR_DATA_UPDATE_PRICES,
      payload: {
        message,
      },
    });
  }
}

function* fetchPrices(action) {
  const token = yield select((state) => state.login.token);
  const auth = { headers: { authorization: `${token}` } };
  const {
    payload: { id },
  } = action;
  const url = `${process.env.REACT_APP_URL}${PROYECT}/stations/${id}/prices`;
  try {
    const response = yield call(api_get, url, auth);

    yield put({
      type: SET_PRICES_UPDATE_PRICES,
      payload: {
        prices: response,
      },
    });
  } catch (message) {
    yield put({
      type: ERROR_PRICES_UPDATE_PRICES,
      payload: { message },
    });
  }
}

function* updatePrice(action) {
  const token = yield select((state) => state.login.token);
  const auth = { headers: { authorization: `${token}` } };
  const {
    payload: { id, idStation, body },
  } = action;
  const url = `${process.env.REACT_APP_URL}${PROYECT}/stations/${idStation}/prices/${id}`;
  try {
    const response = yield call(api_put, url, body, auth);

    yield put({
      type: SET_NEW_PRICE_UPDATE_PRICES,
      payload: {
        product: response,
      },
    });
  } catch (message) {
    yield put({
      type: ERROR_NEW_PRICE_UPDATE_PRICES,
      payload: {
        message,
      },
    });
  }
}

function* updatePriceSaga() {
  yield takeLatest(LOAD_DATA_UPDATE_PRICES, fetchData);
  yield takeLatest(LOAD_PRICES_UPDATE_PRICES, fetchPrices);
  yield takeLatest(SEND_NEW_PRICE_UPDATE_PRICES, updatePrice);
}

export {
  updatePriceReducer,
  getData,
  getPrices,
  sendNewPrice,
  changeCompany,
  changeStation,
  clearError,
  updatePriceSaga,
};
